const Skeleton = () => {
  return <div className='flex flex-col gap-4' data-sentry-component="Skeleton" data-sentry-source-file="skeleton.tsx">
            <div className='mx-auto aspect-square w-64 animate-pulse rounded bg-gray-100' />

            <div className='mx-3 h-6 w-full animate-pulse bg-gray-100' />
            <div className='mx-3 h-6 w-full animate-pulse bg-gray-100' />

            <div className='mx-3 flex gap-1'>
                {Array(15).fill(null).map((_, i) => <div key={i} className='h-10 w-10 shrink-0 animate-pulse rounded bg-gray-100' />)}
            </div>

            <div className='h-11 w-full animate-pulse bg-gray-100' />

            <div className='mx-3 flex justify-between'>
                <div className='h-10 w-30 animate-pulse bg-gray-100' />
                <div className='h-11 w-32 animate-pulse bg-gray-100' />
            </div>
        </div>;
};
export default Skeleton;